// externals
import type { Reducer } from 'redux';

// types
import type { IVehicle } from '@makemydeal/dr-platform-types';

// action types
import { INIT_PENCIL_SUCCESS } from '../actionTypes/initActionTypes';

/**
 * Vehicle reducer to store YMMT data for similarity search.
 * Shared across sales-checkin, choose-vehicle, and open-deal.
 *
 * Note: The absence of a vehicle (null) is handled gracefully by the
 * similarity search selectors in activities-change-vehicle, which
 * normalize null/undefined via `state.vehicle || {}` and guard on
 * required YMMT fields before building the similarity query.
 */
export const reducer: Reducer<IVehicle | null> = (state: IVehicle | null = null, action: any) => {
    switch (action.type) {
        case INIT_PENCIL_SUCCESS: {
            const vehicleData = action.payload?.vehicle;
            if (vehicleData) {
                return vehicleData;
            }
            return state;
        }
        default: {
            return state;
        }
    }
};
